// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const togetic: PokeData = {
  "id": 176,
  "name": "togetic",
  "height": 6,
  "weight": 32,
  "base_experience": 142,
  "types": [
    PokeType.FAIRY,
    PokeType.FLYING
  ],
  "api_moves": [
    "pound",
    "tackle",
    "double-edge",
    "growl",
    "metronome",
    "sweet-kiss",
    "charm",
    "safeguard",
    "baton-pass",
    "encore",
    "ancient-power",
    "follow-me",
    "wish",
    "yawn",
    "air-cutter",
    "extrasensory",
    "magical-leaf",
    "calm-mind",
    "last-resort",
    "air-slash",
    "after-you",
    "bestow",
    "draining-kiss",
    "fairy-wind",
    "moonblast",
    "baby-doll-eyes",
    "life-dew"
  ],
  "moves": [
    "tackle",
    "growl",
    "sweet-kiss",
    "ancient-power",
    "calm-mind",
    "air-slash",
    "moonblast",
    "life-dew",
    "play-rough",
    "dazzling-gleam",
    "mist-terrain",
    "hyper-voice",
    "acrobatics"
  ],
  "evolution_chain": {
    "id": 87,
    "item": null,
    "species": [
      {
        "name": "togepi",
        "order": 203,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "togetic",
        "order": 204,
        "types": [
          PokeType.FAIRY,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 175,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "togekiss",
        "order": 205,
        "types": [
          PokeType.FAIRY,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 176,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "shiny-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 75,
    "speed": 40,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
